import { useSelector } from 'react-redux';
import * as React from 'react';

import { IPageState } from '../../types/page';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { Card } from '../Card';
import { Preloader } from '../Preloader';
import { ResultsEmptyForAuthorizationContainer } from '../../containers/ResultsEmptyForAuthorizationContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { WrapContainer } from '../WrapContainer';
import { isAbUseExperimentGroup, selectExperiments } from '../../selectors/experiments';
import { PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT } from '../../constants/experiments';
import { selectResults } from '../../selectors';

import * as styles from './styles.css';

interface IResultsMobile {
  results: IResultsState;
  page: IPageState;
  isFavoritesForAuthorizationEnabled: boolean;
  removeFavorite(entityId: number): void;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({
  results,
  page,
  isFavoritesForAuthorizationEnabled,
  removeFavorite,
}) => {
  const { status, favoriteEntities, total } = results;

  const { hasMore } = useSelector(selectResults);
  const experiments = useSelector(selectExperiments);
  const isExperimentEnabled = isAbUseExperimentGroup(experiments, PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT, 'B');

  if (favoriteEntities.length === 0) {
    return <ResultsEmptyContainer />;
  }

  if (isFavoritesForAuthorizationEnabled) {
    return <ResultsEmptyForAuthorizationContainer />;
  }

  if (isExperimentEnabled && !hasMore) {
    return (
      <WrapContainer>
        <div className={styles['container']}>
          {favoriteEntities.map((favoriteEntity, index) => (
            <Card
              key={'item-' + favoriteEntity.entityId}
              total={total}
              favoriteEntity={favoriteEntity}
              page={page}
              position={index + 1}
              removeFavorite={removeFavorite}
            />
          ))}
          {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
            <div key="preloader" className={styles['preloader']}>
              <Preloader size={64} />
            </div>
          )}
        </div>
      </WrapContainer>
    );
  }

  return (
    <div className={styles['container']}>
      {favoriteEntities.map((favoriteEntity, index) => (
        <Card
          key={'item-' + favoriteEntity.entityId}
          total={total}
          favoriteEntity={favoriteEntity}
          page={page}
          position={index + 1}
          removeFavorite={removeFavorite}
        />
      ))}
      {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
        <div key="preloader" className={styles['preloader']}>
          <Preloader size={64} />
        </div>
      )}
    </div>
  );
};
